export default function isPreviewMode(req) {
  return req && req.headers && req.headers['x-pga-contentful-preview'] === process.env.PREVIEW_TOKEN
}
